var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDice = function SvgIconDice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M11.676 10.616a2.29 2.29 0 0 0-2.292-2.292H3.551a2.29 2.29 0 0 0-2.292 2.292v5.833a2.294 2.294 0 0 0 2.292 2.292h5.833a2.29 2.29 0 0 0 2.292-2.292zm-2.292 5a.834.834 0 1 0-1.667 0 .834.834 0 0 0 1.667 0m-5-.834a.834.834 0 1 0 0 1.668.834.834 0 0 0 0-1.668M6.468 12.7a.834.834 0 1 0 0 1.667.834.834 0 0 0 0-1.667m2.083-2.083a.834.834 0 1 0 0 1.667.834.834 0 0 0 0-1.667m-3.333.833a.834.834 0 1 0-1.668 0 .834.834 0 0 0 1.668 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M7.107 7.49h2.277c.829 0 1.624.33 2.21.917.586.585.915 1.38.915 2.209v2.16c.687.232 1.16.384 1.19.395a2.293 2.293 0 0 0 2.931-1.38l1.976-5.49a2.29 2.29 0 0 0-1.381-2.931l-5.488-1.976a2.29 2.29 0 0 0-2.933 1.38zm7.649 2.74a.834.834 0 1 0-1.57-.564.834.834 0 0 0 1.57.565m-1.757-3.732a.833.833 0 1 0-.563 1.569.833.833 0 0 0 .563-1.569M12.247 4.9a.834.834 0 1 0-1.57-.564.834.834 0 0 0 1.57.564",
    clipRule: "evenodd"
  })));
};
export default SvgIconDice;